module.exports = __webpack_public_path__ + "img/genetic-upgrades.063aaa5d.jpg";